export default __webpack_public_path__ + "static/media/paneer.f47c263a.jpg";